import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_QUOTE_DETAIL,
  GET_QUOTES,
  GET_QUOTE_COMMENTS,
  GET_AUTH_USER,
  UPDATE_QUOTE,
  DELETE_QUOTE,
} from "./actionTypes"

import {
  deleteQuoteFail,
  deleteQuoteSuccess,

  getQuoteDetailFail,
  getQuoteDetailSuccess,
  getQuotesFail,
  getQuotesSuccess,
  updateQuoteFail
} from "./actions"

//Include Both Helper File with needed methods
import {
  getQuotes,
  getQuoteDetail,
  getQuoteComents as getQuoteComentsApi,
  getAuthUsersResponse,
  updateQuotes,
  deleteQuotesURL
} from "helpers/fakebackend_helper"

function* fetchQuotes(props) {
  try {
    const response = yield call(getQuotes, props.payload)
    yield put(getQuotesSuccess(response))
  } catch (error) {
    yield put(getQuotesFail(error))
  }
}

function* updateQuotesFun(props) {
  try {
    const response = yield call(updateQuotes, props.payload)
    yield put(updateQuoteSuccess(response))
  } catch (error) {
    yield put(updateQuoteFail(error))
  }
}

function* fetchQuoteDetail({ quoteId }) {
  try {
    const response = yield call(getQuoteDetail, quoteId)
    yield put(getQuoteDetailSuccess(response))
  } catch (error) {
    yield put(getQuoteDetailFail(error))
  }
}
function* deleteQuotes(quoteId ) {
  try {
    const response = yield call(deleteQuotesURL, quoteId.payload)
    yield put(deleteQuoteSuccess(response))
  } catch (error) {
    yield put(deleteQuoteFail(error))
  }
}

function* quotesSaga() {
  yield takeEvery(GET_QUOTES, fetchQuotes)
  yield takeEvery(GET_QUOTE_DETAIL, fetchQuoteDetail)
  yield takeEvery(UPDATE_QUOTE, updateQuotesFun)
  yield takeEvery(DELETE_QUOTE,deleteQuotes)
}

export default quotesSaga
